import {
  Camera,
  Layers,
  Network,
  Target,
  RotateCcw,
  ClipboardCheck,
  type LucideIcon,
} from "lucide-react"

export interface Feature {
  icon: LucideIcon
  title: string
  description: string
}

export const features: Feature[] = [
  {
    icon: Camera,
    title: "拍照录入",
    description: "错题、整页试卷都能拍，自动切题、去手写，几秒钟就入库。",
  },
  {
    icon: Layers,
    title: "结构化错题分析",
    description: "每道题分层呈现：原题、错因、正确推导、关联知识点，一眼看懂。",
  },
  {
    icon: Network,
    title: "知识图谱诊断",
    description: "薄弱点不是平铺列表，而是网状依赖：先修哪个、后修哪个，一目了然。",
  },
  {
    icon: Target,
    title: "个性化训练",
    description: "弱点攻克、错因专项、自适应难度，练的就是你需要的。",
  },
  {
    icon: RotateCcw,
    title: "知识闪卡",
    description: "SM-2 算法调度复习节奏，在你即将遗忘时精准推送。",
  },
  {
    icon: ClipboardCheck,
    title: "模考与组卷",
    description: "限时模拟考校准真实水平，按知识点一键组卷，随时自测。",
  },
]
